<template>
  <div class="series-selector-form">
    <div class="columns is-centered">
      <div class="column is-10-tablet is-8-desktop">
        <div class="columns filter-selects">
          <div class="column" v-for="(option) in options" :key="option.handle">
            <div class="form-group">
              <label :for="option.handle">{{ option.label }}</label>
              <select v-if="selected[option.handle] === '' && option.values.length > 1" v-model="selected[option.handle]" :id="option.handle">
                <option v-for="(value) in option.values" :key="value.id" :value="value.id">{{ value.name }}</option>
              </select>
              <div v-else-if="selected[option.handle] === '' && option.values.length === 1" class="default selected-option">{{ option.values[0].name }}</div>
              <div v-else class="selected-option">{{ getSelectedName(selected[option.handle], option.values) }} <a @click="resetSelect(option.handle)"><span class="material-icons" data-localizer="ignore">close</span></a></div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <div><button @click="doSearch()" class="btn-red">Search Products</button></div>
          <div v-if="hasSelections"><button @click="clearSelections()" class="btn-light-grey">Clear Selections</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeriesSelector',
  data () {
    return {
      options: [],
      selected: {},
      hasSelections: false
    }
  },
  created: function () {
    this.getConfigurations()
  },
  watch: {
    selected: {
      deep: true,
      handler () {
        this.hasSelections = false

        const rootObj = this
        Object.keys(rootObj.selected).forEach(function (key) {
          if (rootObj.selected[key] !== '') {
            rootObj.hasSelections = true
          }
        })

        this.getConfigurations()
      }
    }
  },
  methods: {
    async getConfigurations () {
      var postData = JSON.stringify({ selected: this.selected })
      var rootObj = this

      fetch(
        '/get-series-configurations',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          rootObj.options = json.options
          json.options.forEach(function (option) {
            if (!Object.prototype.hasOwnProperty.call(rootObj.selected, option.handle)) {
              rootObj.selected[option.handle] = ''
            }
          })
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    getSelectedName (id, values) {
      let name = ''

      for (let i = 0; i < values.length; i++) {
        if (id === values[i].id) {
          name = values[i].name
        }
      }

      return name
    },
    resetSelect (key) {
      this.selected[key] = ''
    },
    clearSelections () {
      const rootObj = this
      Object.keys(rootObj.selected).forEach(function (key) {
        rootObj.selected[key] = ''
      })
    },
    doSearch () {
      const selectedObj = this.selected
      const selectString = Object.keys(selectedObj).map(function (key) {
        return key + '=' + selectedObj[key]
      }).join('&')
      window.location = '/products?' + selectString
    }
  }
}
</script>
